// extracted by mini-css-extract-plugin
module.exports = {"img":"styles-module--img--2fzPN","wrapper":"styles-module--wrapper--255Wu"};